import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useStudentRole } from "../../RoleProvider/StudentRoleProvider";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import RefreshLoader from "../../SuperAdmin/Loading";

const StudentProtectedRoute = ({ children, requiredRole }) => {
  const { loading: authLoading } = useAuthStudent();
  const { role, isLoading: roleLoading } = useStudentRole();
  const [timeoutReached, setTimeoutReached] = useState(false);

  useEffect(() => {
    let timer;

    if (roleLoading || role === null) {
      // 5 seconds timeout
      timer = setTimeout(() => {
        setTimeoutReached(true);
      }, 5000);
    }

    return () => clearTimeout(timer);
  }, [roleLoading, role]);

  if (authLoading) {
    return <RefreshLoader />;
  }

  if ((roleLoading || role === null) && !timeoutReached) {
    return <RefreshLoader />;
  }

  if ((roleLoading || role === null) && timeoutReached) {
    return <Navigate to="/login" replace />;
  }

  if (role !== requiredRole) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default StudentProtectedRoute;
